import { Calendar } from 'lucide-react'
import { usePYQAnalyticsStore } from '../../../stores/pyqAnalyticsStore'

const currentYear = new Date().getFullYear()
const startYears = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i)
const endYears = Array.from({ length: currentYear - 1990 + 1 }, (_, i) => 1990 + i)

export default function YearRangeFilter() {
  const { yearRangeStart, yearRangeEnd, setYearRange } = usePYQAnalyticsStore()

  const handleStartChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newStart = parseInt(e.target.value, 10)
    if (newStart <= yearRangeEnd) {
      setYearRange(newStart, yearRangeEnd)
    }
  }

  const handleEndChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newEnd = parseInt(e.target.value, 10)
    if (newEnd >= yearRangeStart) {
      setYearRange(yearRangeStart, newEnd)
    }
  }

  return (
    <div className="flex items-center gap-3 bg-white rounded-lg border border-gray-200 px-4 py-2">
      <Calendar className="w-4 h-4 text-gray-500" />
      <span className="text-sm text-gray-600">Year Range:</span>
      <select
        value={yearRangeStart}
        onChange={handleStartChange}
        className="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {startYears.map((year) => (
          <option key={year} value={year} disabled={year > yearRangeEnd}>
            {year}
          </option>
        ))}
      </select>
      <span className="text-gray-400">to</span>
      <select
        value={yearRangeEnd}
        onChange={handleEndChange}
        className="px-2 py-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        {endYears.map((year) => (
          <option key={year} value={year} disabled={year < yearRangeStart}>
            {year}
          </option>
        ))}
      </select>
    </div>
  )
}
